import React, {Component} from "react";

export class Loading extends Component {
    render(){
        return(
            <div className={`loading-request-details-holder width-100 text-align-center ${this.props.customClass}`}>
                <div className="lds-default">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <span className="loading-label">{this.props.label}</span>
                </div>               
            </div>
        )
    }
}